import React, { Suspense, useState } from 'react';
import LazyLoad, { lazyload } from 'react-lazyload';
import { Lottie } from '@crello/react-lottie';

import Head from 'next/head';

import st from './index.module.scss';

import Pricing from '../../../components/video-production/Pricing';
import BradCrumbs from '../../../components/Base/BradCrumbs';
import Engagement from '../../../components/Engagement';
import Faq from '../../../components/Faq';
import ProcessSlider3D from '../../../components/sliders/ProcessSlider3D';
import typesLottie from '../../../public/images/types.json';
import SolveProblems3D from '../../../components/video-production/explainer-videos/SolveProblems3D';
import Why from '../../../components/Why';
import ViewMore from '../../../components/ViewMore';
import Benefits3D from '../../../components/video-production/explainer-videos/Benefits3D';

lazyload({
  width: '100%',
});

const ExplainerVideos3D = props => {
  const [showPricingModalF, setShowPricingModalF] = useState(false);
  const [videoLength, setVideoLength] = useState([]);
  const [script, setScript] = useState([]);

  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing';
    } else {
      setShowPricingModalF(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      window.location.hash = 'open';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalF(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    history.replaceState(null, null, ' ');
    document.documentElement.style.overflow = 'auto';
  };

  return (
    <>
      <Head>
        <title>Video Production - 3D Explainer Video | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/video-production/3d-explainer-video" />
        <meta
          name="description"
          content="Bring your ideas to life with our custom 3D animated explainer videos. We create visually stunning and compelling content to boost your brand."
        />
        <meta property="og:url" content="https://weprodigi.com/video-production/3d-explainer-video" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Video Production - 3D Explainer Video | Prodigi" />
        <meta
          property="og:description"
          content="Bring your ideas to life with our custom 3D animated explainer videos. We create visually stunning and compelling content to boost your brand."
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/explainer-videos/3d-explainer/og.jpg" />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `{
              "@context": "http://schema.org",
              "@type": "WebPage",
              "name": "3D Explainer Video",
              "description": "Bring your ideas to life with our custom 3D animated explainer videos. We create visually stunning and compelling content to boost your brand.",
              "url": "https://weprodigi.com/video-production/whiteboard-explainer-video",
              "breadcrumb": {
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://weprodigi.com"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Full Service Video Production",
                    "item": "https://weprodigi.com/video-production"
                  },
                  {
                    "@type": "ListItem",
                    "position": 3,
                    "name": "3D Explainer Video Production",
                    "item": "https://weprodigi.com/video-production/whiteboard-explainer-video"
                  }
                ]
              },
              "mainEntity": {
                "@type": "Product",
                "name": "3D Explainer Video Production",
                "description": "Bring your ideas to life with our custom 3D animated explainer videos.We create visually stunning and compelling content to boost your brand and tell your story effectively.",
                "brand": {
                  "@type": "Brand",
                  "name": "Weprodigi"
                },
                "offers": {
                  "@type": "Offer",
                  "price": "2700",
                  "priceCurrency": "USD",
                  "seller": {
                    "@type": "Organization",
                    "name": "Weprodigi"
                  }
                },
                "image": "https://weprodigi.com/images/logovertical.svg",
                "review": [
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "5",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "David Thompson"
                    },
                    "datePublished": "2024-01-14",
                    "reviewBody": "Top-notch quality, highly recommend!"
                  },
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "5",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Michael Brown"
                    },
                    "datePublished": "2024-02-17",
                    "reviewBody": "Outstanding work, attention to detail, impressive storytelling!"
                  },
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "4.9",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Sarah Davis"
                    },
                    "datePublished": "2024-02-2",
                    "reviewBody": "Creative excellence, seamless process, highly professional team!"
                  }
                ],
                "aggregateRating": {
                  "@type": "AggregateRating",
                  "ratingValue": "4.9",
                  "reviewCount": "3"
                }
              }
            }
            `,
          }}
        />
      </Head>

      {/*    Header video */}
      <div className={`relative w-full  h-intro  overflow-hidden  `}>
        <video
          width="100%"
          height="100%"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          id="header-11"
          className={'absolute h-intro md:h-full ' + st['header-mp4']}
        >
          <source src="https://weprodigi.com/uploads/images/explainer-videos/3d-explainer/3d-explainer.mp4" type="video/mp4" />
        </video>
        <div className={st['overlay']}></div>
        <div className="container h-full">
          <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
            <h1 className="max-w-300 md:max-w-600 uppercase md:normal-case text-white text-30 md:text-72 font-black md:font-bold leading-tight">
              3D Explainer Video Production
            </h1>
            <a
              onClick={showPricingModal}
              className="relative flex items-center justify-center min-w-250 z-10 border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 mt-48 md:mt-23 py-8 bg-green-badge hover:bg-green-hover hover:text-white transition-all   transition-400 cursor-pointer"
            >
              Get Pricing
              <img src="https://weprodigi.com/uploads/images/explainer-videos/buttonIcon.svg" className={'ml-10'} alt="pricing icon" />
            </a>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container">
          <BradCrumbs
            items={[
              {
                url: '/video-production',
                name: 'Video Production',
              },
              {
                url: '/video-production/explainer-videos',
                name: 'Explainer Video Production',
              },
              {
                url: '/video-production/3d-explainer-video',
                name: '3D Explainer Video',
              },
            ]}
          />
          <div className="relative pt-20 md:pt-0 pb-48">
            <div className="flex flex-wrap md:flex-nowrap justify-between">
              <LazyLoad className="mr-auto mt-24 md:mt-0 max-w-270 w-full md:w-auto" height={200} once>
                <Lottie
                  config={{
                    animationData: typesLottie,
                    loop: true,
                    autoPlay: true,
                  }}
                  playingState="playing"
                />
              </LazyLoad>
              <div className="flex flex-col ml-12 items-center justify-center max-w-756">
                <Engagement title="Video">
                  A 3D explainer video is a magical door to the virtual world filled with artistry and realism. Here, all creative ideas come true in
                  skilled hands. Let's get through that door and learn more about awesome 3D animated explainer videos.
                </Engagement>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LazyLoad height={200} once>
        <div className={'bg-gray-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-half-auto font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              What Is 3D Explainer Video Animation?
            </h2>

            <div className={'block md:flex justify-between flex-row md:flex-row-reverse'}>
              <div className=" pl-0 md:pl-20 pb-10 w-full md:w-half-auto block  mt-23 mb-10">
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/EKuZg7rkt14?controls=0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Dilijan Beers | 3D Animation</p>
              </div>

              <p className={'mt-20 w-half-auto hidden md:block'}>
                A 3D explainer video is like a magnetic mini-movie. Objects and characters come alive in 3D reality. It seems that they are born in
                the depths of virtual space and pop up on the screen. The wonderful illusion of lively movement is used to present products, services,
                and various ideas. Any information becomes easy to understand and fun with high-quality 3D animated video services. Just remember the
                most impressive 3D explainer videos you've ever seen. Can you imagine a more realistic way to bring your ideas to life?
              </p>
              <div className={'mt-20 block md:hidden'}>
                <ViewMore ln={40}>
                  A 3D explainer video is like a magnetic mini-movie. Objects and characters come alive in 3D reality. It seems that they are born in
                  the depths of virtual space and pop up on the screen. The wonderful illusion of lively movement is used to present products,
                  services, and various ideas. Any information becomes easy to understand and fun with high-quality 3D animated video services. Just
                  remember the most impressive 3D explainer videos you've ever seen. Can you imagine a more realistic way to bring your ideas to life?
                </ViewMore>
              </div>
            </div>
            <br className={'clear-both hidden'} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-75p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Where to Use 3D Explainer Video Animation?
            </h2>
            <p className={'mt-20'}>
              Users spend 18 hours per week watching online videos. Your potential clients, learners, or employees do the same. Why not try to "steal"
              1-2 minutes from this amount of time to create meaningful connections with them? One of the best ways is through 3D video animation
              services. Depending on the industry, they can meet different objectives.
            </p>

            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between items-start mt-0 md:mt-24">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/UHCqHK84izk?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Geo Group | Manufacturing 3D Explainer Animation</p>
              </div>

              <div className={'w-full md:w-half-auto mt-24 md:mt-0'}>
                <h3 className="text-purple font-bold text-24   leading-none">Marketing and Advertising</h3>
                <div className={'mt-16 hidden md:block'}>
                  A 3D explainer video is a great way to showcase your physical product or service. Help your potential customers quickly understand
                  why the benefits of your offer matter to them. Include a 3D explainer video on your website to improve search engine rankings and
                  increase website traffic. With a well-crafted explainer video, you can also add a level of 3D allure, realism, and creativity to
                  your advertising campaigns on social media and online platforms.
                </div>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    A 3D explainer video is a great way to showcase your physical product or service. Help your potential customers quickly understand
                    why the benefits of your offer matter to them. Include a 3D explainer video on your website to improve search engine rankings and
                    increase website traffic. With a well-crafted explainer video, you can also add a level of 3D allure, realism, and creativity to
                    your advertising campaigns on social media and online platforms.
                  </ViewMore>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap md:flex-nowrap justify-between mt-0 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <h3 className="text-purple font-bold text-24 leading-none">Education and Training</h3>
                <p className={'mt-16'}></p>

                <p className={'mt-16 hidden md:block'}>
                  91% of schools and colleges find that videos make students happier with their learning. Adding impressive 3D videos makes this
                  effect even stronger. Use their power to create engaging online courses that make even the most tough topics interactive and fun.
                  Plus, you can add 3D explainer videos to lectures and textbooks to enrich the regular learning experience. 3D animated videos are
                  also perfect for sharing insights and knowledge and positioning yourself as an expert.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    91% of schools and colleges find that videos make students happier with their learning. Adding impressive 3D videos makes this
                    effect even stronger. Use their power to create engaging online courses that make even the most tough topics interactive and fun.
                    Plus, you can add 3D explainer videos to lectures and textbooks to enrich the regular learning experience. 3D animated videos are
                    also perfect for sharing insights and knowledge and positioning yourself as an expert.
                  </ViewMore>
                </div>
              </div>
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/GcfJTZiAmd4?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Status Cards | Financial 3D Explainer Animation</p>
              </div>
            </div>
            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between mt-24 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/1dgg2bGmE70?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Alto Displays | 3D Explainer Animation</p>
              </div>

              <div className={'w-full md:w-half-auto '}>
                <h3 className="text-purple font-bold text-24 leading-none">Social Awareness and Advocacy</h3>
                <p className={'mt-16 hidden md:block'}>
                  Research shows that viewers recall 95% of information when they watch it in a video, and 10% when they read it. This big difference
                  highlights the power and value of video in communication, especially in the social field. Make use of the the charm of a 3D
                  explainer video to more successfully connect with different groups of people, raise awareness of key problems, and encourage
                  advocacy.These striking animations evoke deep emotions, inspire social changes and progress.{' '}
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={'40'}>
                    Research shows that viewers recall 95% of information when they watch it in a video, and 10% when they read it. This big
                    difference highlights the power and value of video in communication, especially in the social field. Make use of the the charm of
                    a 3D explainer video to more successfully connect with different groups of people, raise awareness of key problems, and encourage
                    advocacy.These striking animations evoke deep emotions, inspire social changes and progress.
                  </ViewMore>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-gray-light py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>Benefits of 3D Explainer Video</h2>
            <p className={'mt-20'}>
              A 3D explainer video is ahead of a number of its counterparts both in costs and the length of the production process. But does this fact
              overshadow its power and effectiveness? NOT. It provides benefits that no other video style can offer.
            </p>
            <Suspense fallback={`Loading...`}>
              <Benefits3D />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="text-purple text-24 md:text-36 text-left mb-23 font-black uppercase leading-none">
              Our 3D Explainer Video Animation Process
            </h2>
            <ProcessSlider3D />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={0} once>
        <div className={'h-500 md:h-310 overflow-hidden relative ' + st['bg-contact']}>
          <div id="stars" />
          <div id="stars2" />
          <div id="stars3" />
          <div className="container flex flex-wrap md:flex-nowrap justify-between items-end md:items-center h-full ">
            <div className={'mt-24 md:mt-0 text-left md:text-center font-bold uppercase  text-white leading-28 md:leading-44   text-20 md:text-36'}>
              CALCULATE YOUR 3D EXPLAINER VIDEO PRICE
              <br />
              <span className={'pt-20 font-normal normal-case text-18 md:text-24 leading-20 md:leading-29 '}>
                Answer five questions and get to know the price!
              </span>
              <div className={'flex justify-end md:justify-center mt-0 leading-0'}>
                <button
                  onClick={showPricingModal}
                  className="uppercase h-40 text-18 leading-24  hover:bg-green-hover md:flex justify-center items-center   w-auto mt-24 text-white bg-green rounded-5 px-23 py-0 md:py-5"
                >
                  Start Now
                </button>
              </div>
            </div>
            <img src="https://weprodigi.com/uploads/images/explainer-videos/Inga.webp" alt="eva" className={st['inga']} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              How 3D Animated Explainer Video Can Help Your Business?
            </h2>
            <p className={'mt-20'}>
              3D explainer videos are impressive with their depth and splendor. But that is only the external side of their charm. They are also
              powerful as business tools.
            </p>
            <Suspense fallback={`Loading...`}>
              <SolveProblems3D />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-gray-light">
          <div className="container py-23">
            <h2 className="uppercase text-30 md:text-36 mb-23 font-black text-purple leading-none">
              Why Choose Us for Your 3D Explainer Video Production?
            </h2>
            <Why
              content={[
                {
                  title: 'We provide full-modeling services.',
                  answer: 'Our skilled specialists do accurate and precise modeling to create life-like 3D visualizations.',
                },
                {
                  title: 'We craft captivating narratives',
                  answer:
                    'One of our strengths as a 3D animated video company is that our animations not only engage the audience. They create a strong response and vividly imprint themselves in their memory.',
                },
                {
                  title: 'We value your time.',
                  answer:
                    "Both our time and yours are precious. That's why our 3D video animation company offers custom services to help minimize the time for video production.",
                },
                {
                  title: 'We focus on collaboration.',
                  answer: 'Throughout the production, you are an active part of the process. Your opinion is vital for us at every stage.',
                },
              ]}
            />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none">FAQ</h2>
            <div className="grid md:grid-cols-2 md:gap-30">
              <Faq
                content={[
                  {
                    title: 'How long should a 3D explainer video last?',
                    answer:
                      'The shorter, the better. A high-quality 3D animated explainer video, typically 45-60 seconds long, with a clear call to action at the end, is often the most effective.',
                  },
                  {
                    title: 'How effective are 3D explainer videos? ',
                    answer:
                      'A 3D explainer video is more realistic, immersive, and visually appealing. It can powerfully describe any product, service, and even an abstract idea in a meaningful way.',
                  },
                ]}
              />
              <Faq
                content={[
                  {
                    title: 'How much do 3D explainer videos cost?',
                    answer:
                      'Production of a 45-second 3D explainer video, which includes in-depth research, script writing, storyboarding, illustrations, sound design, and unlimited revisions, costs $2,250.',
                  },
                  {
                    title: 'What is the goal of a 3D explainer video?',
                    answer:
                      'A 3D explainer video is a dynamic and effective tool for communicating ideas, showcasing products, and engaging audiences. It is widely used for marketing, education, and communication.',
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>

      <Pricing videoLength={videoLength} script={script} country={props.country} show={showPricingModalF} hide={hidePricingModal} step={1} />
    </>
  );
};

export default ExplainerVideos3D;
